import type {
  AnimationBindingResolver,
  AnimationBindingTarget,
  AnimationTargetRef,
} from '@/shared/types/animation'
import type { Disposable } from '@/shared/types/core'

export class AnimationBindingRegistry {
  private readonly resolvers = new Map<string, AnimationBindingResolver>()

  register(kind: string, resolver: AnimationBindingResolver): Disposable {
    if (!kind) {
      throw new Error('Animation binding kind is required')
    }
    if (this.resolvers.has(kind)) {
      throw new Error(`Animation binding kind "${kind}" has already been registered`)
    }

    this.resolvers.set(kind, resolver)
    return {
      dispose: () => {
        if (this.resolvers.get(kind) === resolver) {
          this.resolvers.delete(kind)
        }
      },
    }
  }

  resolve(targetRef: AnimationTargetRef): AnimationBindingTarget | null {
    const resolver = this.resolvers.get(targetRef.kind)
    return resolver?.resolve(targetRef) ?? null
  }

  clear(): void {
    this.resolvers.clear()
  }
}
